import * as React from 'react';

import { useGlobalDOMEvent } from './useGlobalDOMEvent';

interface UseUserInteractionProps {
  timeoutSeconds: number;
  disabled?: boolean;
}

export const useUserInteraction = ({ timeoutSeconds, disabled }: UseUserInteractionProps): boolean => {
  const [hasInteracted, setHasInteracted] = React.useState(disabled ?? false);
  function cb() {
    setHasInteracted(true);
    clearTimeout(timeout);
  }

  useGlobalDOMEvent({
    keydown: cb,
    touchmove: cb,
    mousemove: cb,
  });

  // recognize timeout as interaction
  const timeout = setTimeout(cb, 1000 * timeoutSeconds);

  return hasInteracted;
};
